import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingPromoLabel } from '../../../components/NewbuildingPromoLabel';
import { getPromoLabelContent } from '../../../selectors/newObject';

export const NewbuildingPromoLabelContainer: React.FC = () => {
  const text = useSelector(getPromoLabelContent);

  if (!text) {
    return null;
  }

  return <NewbuildingPromoLabel text={text} />;
};
